$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  const locationId = $('body').attr('event_id');

  if (p === 'reconciliation') {
    let page = 1;

    //start-end date filter
    $(document).on('change', '#start-date', function (e) {
      const startDate = $(this).val();
      const endDate = $('#end-date').val();

      if (checkDateValidation(startDate, endDate)) {
        getTerminalReconciliation(locationId, startDate, endDate);
      } else {
        $(this).focus();
        return;
      }
    });

    $(document).on('click', '.pagination a', function (e) {
      e.preventDefault();
      const filterStartDate = $('#start-date').val();
      const filterEndDate = $('#end-date').val();
      page = parseInt($(this).attr('href').substring(6));
      getTerminalReconciliation(
        locationId,
        filterStartDate,
        filterEndDate,
        page
      );
    });

    $(document).on('change', '#end-date', function (e) {
      const endDate = $(this).val();
      const startDate = $('#start-date').val();

      if (checkDateValidation(startDate, endDate)) {
        getTerminalReconciliation(locationId, startDate, endDate);
      } else {
        $(this).focus();
        return;
      }
    });

    function checkDateValidation(filterStartDate, filterEndDate) {
      if (!filterStartDate || !filterEndDate) {
        alert('Både startdato og sluttdato er obligatorisk.');
        return false;
      }

      if (new Date(filterEndDate) < new Date(filterStartDate)) {
        alert('Sluttdato kan ikke være før startdato.');
        return false;
      }

      return true;
    }

    function getTerminalReconciliation(locationId, startDate, endDate, page) {
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/reconciliation/search',
        data: {
          location_id: locationId,
          start_date: startDate,
          end_date: endDate,
          page,
        },
      })
        .done(function (data) {
          if (data.html && data.html !== null && data.html !== '') {
            $('#terminal-reconciliation-list-view').empty();
            $('#terminal-reconciliation-list-view').html(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
